import { render } from "./EmpPolicySvg.vue?vue&type=template&id=1c8dbd70"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__